import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/legacy_workflows_analytics_event.py
export const LEGACY_WORKFLOWS_ANALYTICS_ACTIONS = {
  // READ actions
  DOWNLOADED_INPUT_TABLE_AS_CSV: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'downloaded_input_table_as_csv',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DOWNLOADED_TRANSFER_TABLE_AS_CSV: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'downloaded_transfer_table_as_csv',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_STAGE_ENTRY: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'opened_stage_entry',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_LEGACY_WORKFLOW_DASHBOARD: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'opened_workflow_dashboard',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_LEGACY_WORKFLOW_SUMMARY_VIEW: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'opened_workflow_summary_view',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_LEGACY_WORKFLOW_TEMPLATE: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'opened_workflow_template',
    actionCategory: ACTION_CATEGORY.READ,
  },

  // WRITE actions
  ADDED_INPUT_TABLE_SAMPLES_FROM_SPREADSHEET_IMPORT: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'added_input_table_samples_from_spreadsheet_import',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  AUTOSELECTED_INPUT_CONTAINERS: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'autoselected_input_containers',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  COMPLETED_LEGACY_WORKFLOW: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'completed_workflow',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_DATA_TABLE_IN_ENTRY: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'created_data_table_in_entry',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_DATA_TABLE_CONFIG: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'created_data_table_config',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_TRANSFER_TABLE_IN_ENTRY: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'created_transfer_table_in_entry',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_TRANSFER_TABLE_CONFIG: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'created_transfer_table_config',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_LEGACY_WORKFLOW: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'created_workflow',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DUPLICATED_BRANCH: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'duplicated_branch',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  FILLED_NEXT_AVAILABLE_POSITIONS_FROM_TRANSFER_TABLE: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'filled_next_available_positions_from_transfer_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  RERAN_STAGE_RUN: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'reran_stage_run',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SPLIT_BY_CONDITION: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'split_by_condition',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SPLIT_BY_INPUTS: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'split_by_inputs',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  TRANSFERRED_SAMPLES_FROM_TABLE: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'transferred_samples_from_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_STAGE: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'updated_stage',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_STAGE_ENTRY: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'updated_stage_entry',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_STAGE_RUN: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'updated_stage_run',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_STAGE_RUN_STATUS: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'updated_stage_run_status',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_LEGACY_WORKFLOW_TEMPLATE: {
    module: ANALYTICS_MODULE.LEGACY_WORKFLOWS,
    action: 'updated_workflow_template',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
